export const DEFAULT_SITE_CONTENT = {
  hero_headline_line1: "Do More Than",
  hero_headline_line2: "Just Exist",
  hero_subheadline:
    "Coach Conde builds no-nonsense strength, fat-loss and mobility programs for Bay Area professionals \u2014 in-person across Oakland, SF & Silicon Valley, or fully online.",
  hero_tag_experience: "15+ Years Experience",
  hero_tag_location: "Oakland \u00b7 SF \u00b7 Silicon Valley",
  hero_stat_lives: "100+ Lives Transformed",
  hero_stat_years_label: "15+ Years",
  hero_stat_rating_label: "Bay Area Rated",
  service_area_title: "Coaching Across The Bay",
  service_area_body:
    "In-person training in Oakland, San Francisco and Silicon Valley \u2014 plus travel/in-home sessions and fully virtual coaching for anywhere in the Bay Area.",
  service_area_badge_1: "Oakland",
  service_area_badge_2: "San Francisco",
  service_area_badge_3: "Peninsula",
  service_area_badge_4: "Silicon Valley / South Bay",
  booking_title: "Let's Build Your Plan",
  booking_subtitle:
    "15-minute call with Coach Conde to talk goals, schedule and the right package for you \u2014 individual, corporate, or class pass.",
  footer_tagline: "Do More Than Just Exist \u2014 Exist Fit.",
  footer_subtext: "Coaching the Bay Area since 2011.",
  services_eyebrow: "Services & Packages",
  services_title: "Built For Every Goal",
  services_group_intro_title: "Introductory & Class Passes",
  services_group_intro_subtitle: "Dip your toes in or grab a flexible pass \u2014 no long-term commitment.",
  services_group_memberships_title: "Monthly Training Memberships",
  services_group_memberships_subtitle: "Consistent, ongoing coaching built around your specific goal.",
  services_group_addons_title: "Add-Ons & Specialized Services",
  services_group_addons_subtitle: "Layer on extra support, wherever and however you train.",
  service_image_travel_addon: "https://images.unsplash.com/photo-1648542036561-e1d66a5ae2b1",
  quiz_eyebrow: "Find Your Fitness Path",
  quiz_title: "3 Questions. Zero Guesswork.",
  quiz_step1_question: "What's your main goal?",
  quiz_step1_subtitle: "Select all that apply.",
  quiz_step2_question1: "Experience level?",
  quiz_step2_question2: "Where will you train?",
  quiz_step3_question: "Where should we send your plan?",
  quiz_success_title: "You're On The List",
  quiz_success_body: "Coach Conde reviews every submission personally and will text or email you within 24 hours.",
};
